import { connect } from "react-redux";

import RouteRegionSeparator from "./RouteRegionSeparator";

import { excludeCountry } from "../../store/actions";

const mapDispatchToProps = dispatch => ({
  excludeCountry: country => dispatch(excludeCountry(country)),
});

export default connect(
  null,
  mapDispatchToProps,
)(RouteRegionSeparator);
